import React from 'react';
import { Container, Button } from '../ui';
import { SALES_EMAIL, SALES_PHONE, SALES_PHONE_HREF, WEBSITE } from '../../data/marketing';

// Company identity + local support + Spanish readiness. Real contact info.
const LocalSupport = ({ onRequestDemo }) => (
  <section id="support" className="bg-white py-16 sm:py-24 scroll-mt-16">
    <Container>
      <div className="rounded-3xl bg-brand-gradient text-white overflow-hidden relative">
        <div className="absolute inset-0 bg-brand-mesh opacity-40" />
        <div className="relative grid grid-cols-1 lg:grid-cols-2 gap-8 p-8 sm:p-12 items-center">
          <div>
            <span className="text-xs font-semibold uppercase tracking-widest text-accent-300">Local support</span>
            <h2 className="mt-2 text-3xl sm:text-4xl font-extrabold font-display leading-tight">
              RGV-built, with real local support
            </h2>
            <p className="mt-3 text-brand-100 max-w-md">
              Valley Tickets is built in the Rio Grande Valley for RGV school districts. We help with setup,
              launch, and event-day support, so your staff are never on their own at the gate.
            </p>
            <div className="mt-5 inline-flex items-center gap-2 rounded-full bg-white/10 ring-1 ring-white/20 px-4 py-2 text-sm">
              <span className="text-accent-300">🗣️</span>
              <span>Hablamos español — Spanish-friendly parent experience planned; Spanish support available upon request.</span>
            </div>
          </div>

          <div className="bg-white rounded-2xl p-6 text-ink-900 shadow-lift">
            <h3 className="font-bold font-display text-lg">Talk to a real person</h3>
            <p className="text-sm text-ink-500 mt-1">Setup, launch, and event-day help.</p>
            <div className="mt-4 space-y-3 text-sm">
              <a href={`tel:${SALES_PHONE_HREF}`} className="flex items-center gap-3 hover:text-brand-700">
                <span className="w-9 h-9 rounded-xl bg-brand-50 flex items-center justify-center">📞</span>
                <span className="font-semibold">{SALES_PHONE}</span>
              </a>
              <a href={`mailto:${SALES_EMAIL}`} className="flex items-center gap-3 hover:text-brand-700">
                <span className="w-9 h-9 rounded-xl bg-brand-50 flex items-center justify-center">✉️</span>
                <span className="font-semibold break-all">{SALES_EMAIL}</span>
              </a>
              <a href={`https://${WEBSITE}`} className="flex items-center gap-3 hover:text-brand-700">
                <span className="w-9 h-9 rounded-xl bg-brand-50 flex items-center justify-center">🌐</span>
                <span className="font-semibold">{WEBSITE}</span>
              </a>
            </div>
            <Button onClick={onRequestDemo} className="mt-5 w-full">Request a demo</Button>
          </div>
        </div>
      </div>
    </Container>
  </section>
);

export default LocalSupport;
